import { makeAutoObservable } from 'mobx'
import { SingletonInitService } from '../services/SingletonInitService'

export class FbeAuthStore {
  singletonInitService: SingletonInitService
  constructor() {
    makeAutoObservable(this)
    this.singletonInitService = new SingletonInitService()
  }

  init = async () => {
    // eslint-disable-next-line no-empty
    if (this.singletonInitService.getWasInit()) {

    }
  }
}
